import './imask-number-defaults.patch';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';

import { AppModule } from '@app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  Sentry.init({
    dsn: 'https://09b5515c229a48e4a1152535ffc96f96@o1146485.ingest.sentry.io/6215275',
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: ['localhost'],
    tracesSampleRate: 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      /ChunkLoadError: Loading chunk/g,
      /Invalid Date/g,
      /ApolloError.*401/g,
      /ApolloError.*Failed to fetch/g,
      /Failed to fetch dynamically imported module/g,
    ],
  });

  enableProdMode();
}

registerLocaleData(localeEn);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
